import { ReactElement, SVGProps } from 'react'
export const SvgStar = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
    <path
      fill="currentColor"
      d="m35.473 13.793-9.918-1.441-4.434-8.989a1.243 1.243 0 0 0-.566-.566 1.255 1.255 0 0 0-1.676.566l-4.434 8.989-9.918 1.441a1.247 1.247 0 0 0-.691 2.133l7.176 6.996L9.316 32.8a1.248 1.248 0 0 0 1.813 1.316L20 29.453l8.871 4.664a1.248 1.248 0 0 0 1.813-1.316l-1.696-9.88 7.176-6.995c.195-.192.324-.442.363-.715a1.246 1.246 0 0 0-1.054-1.418Z"
    />
  </svg>
)
